import { NavLink } from "react-router-dom";

const TABS = [
  { label: "Infrastructure", to: "/capabilities/infrastructure", no: "01" },
  { label: "Products", to: "/capabilities/products", no: "02" },
];

export default function CapabilityTabs() {
  return (
    <div className="border-b border-border sticky top-[88px] z-40 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <div className="flex gap-0 overflow-x-auto">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={`cap-tab-${t.no}`}
              className={({ isActive }) =>
                `group flex items-center gap-2 whitespace-nowrap px-5 md:px-7 py-5 border-r border-border text-[13px] font-medium transition-colors ${
                  isActive ? "text-foreground bg-secondary" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span className={`font-mono-tech text-[10px] ${isActive ? "text-[hsl(var(--signal))]" : "text-muted-foreground"}`}>
                    {t.no}
                  </span>
                  {t.label}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}
